import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 92.25 122.88"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "46.12",
      cy: "46.76",
      r: "24.63",
      style: {"fill":"#eaf2fb"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M49.1 122.34c-.92.68-2.16.72-3.12.1A109.7 109.7 0 0 1 19 98.35C9.15 86 3 72.33.83 59.16-1.33 45.79.69 32.94 7.34 22.49c2.71-4.25 6.1-8.01 10.05-11.14C26.77 3.87 37.49-.08 48.16 0c10.29.08 20.43 3.92 29.2 11.91 3.04 2.77 5.66 5.97 7.79 9.49 7.15 11.77 8.69 26.8 5.55 42a92.51 92.51 0 0 1-41.6 58.92zm-3-98.58C58.8 23.73 69.13 34 69.16 46.7S58.92 69.73 46.22 69.76 23.19 59.52 23.16 46.82v-.06c0-12.69 10.28-22.98 22.97-23z",
      style: {"fill":"#065ba2","fill-rule":"evenodd"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mapmarker-blue-new"}) } }